export function isDisabled(items: number, isStaff: boolean): boolean {
  return !isStaff && items === 0 ? true : false;
}
